import { CodeSyntax } from '@carbon/pictograms-react';
import { NetworkServices } from '@carbon/pictograms-react';
import { CarbonForIbmDotcom } from '@carbon/pictograms-react';
import { Kubernetes } from '@carbon/pictograms-react';
import { Connect } from '@carbon/pictograms-react';
import { Transform_02 } from '@carbon/pictograms-react';
import { Analyze } from '@carbon/pictograms-react';
import { Process } from '@carbon/pictograms-react';
import { AccessManagement } from '@carbon/pictograms-react';
import { KnowsDarkData } from '@carbon/pictograms-react';
import { Security_02 } from '@carbon/pictograms-react';
import { Renew } from '@carbon/pictograms-react';
import * as React from 'react';
export default {
  CodeSyntax,
  NetworkServices,
  CarbonForIbmDotcom,
  Kubernetes,
  Connect,
  Transform_02,
  Analyze,
  Process,
  AccessManagement,
  KnowsDarkData,
  Security_02,
  Renew,
  React
};